import { VBtn, VIcon } from "vuetify/lib";

export default {
	name: "KColorSwatch",

	props: {
		color: {
			default: "#000",
			type: String
		},

		selectable: {
			default: true,
			type: Boolean
		},

		selected: Boolean
	},

	render() {
		return <VBtn
			attrs={this.$attrs}
			class="k-color-swatch"
			color={this.color ? this.color : "#000"}
			dark
			depressed
			fab
			on={this.$listeners}
			ripple={this.selectable}
			small
			tag={this.selectable ? "button" : "span"}
		>
			{this.selected && <VIcon>check</VIcon>}
		</VBtn>;
	}
};
